import React from 'react'

import Heading from './Heading'

export default level => {
  const Composed = props => <Heading level={level} {...props} />
  Composed.displayName = `Heading${level}`
  return Composed
}
